import { useState } from 'react';
import axios from 'axios';
import config from '@/envConfig/envConfig';

interface DetachPaymentMethodParams {
  paymentMethodId: string;
}

interface UseDetachPaymentMethodReturn {
  detachPaymentMethod: (params: DetachPaymentMethodParams) => Promise<any | null>;
  loading: boolean;
  error: string | null;
  detachedPaymentMethod: any | null;
}

export const useDetachPaymentMethod = (): UseDetachPaymentMethodReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [detachedPaymentMethod, setDetachedPaymentMethod] = useState<any | null>(null);

  const detachPaymentMethod = async (params: DetachPaymentMethodParams): Promise<any | null> => {
    const { paymentMethodId } = params;

    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        `${config.stripeApiUrl}/payment_methods/${paymentMethodId}/detach`,
        {},
        {
          headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      const responseData = response.data;
      setDetachedPaymentMethod(responseData);
      return responseData;
    } catch (err) {
      const errorMessage = axios.isAxiosError(err)
        ? err.response?.data?.error?.message || err.message
        : 'An unknown error occurred';
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    detachPaymentMethod,
    loading,
    error,
    detachedPaymentMethod,
  };
};

export default useDetachPaymentMethod;